module.exports = __webpack_public_path__ + "static/img/Newimg9.33ed196.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Newimg9.png
// module id = Lr9Q
// module chunks = 46